"use client";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { getFormatMedia, restoreMUIGridToOldVersion } from "~/theme/utils";

import { ARTICLE_PRODUCT_CARD_CLASSES } from "./constants";

export const ArticleProductCardContainer = styled(Box)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    marginBottom: theme.spacing(6.5),

    "& .MuiGrid-container": restoreMUIGridToOldVersion(theme),
    [formatMedia.BREAKPOINT_TABLET]: {
      marginBottom: theme.spacing(8),
    },
    [`& .${ARTICLE_PRODUCT_CARD_CLASSES.grid}`]: {
      display: "flex",
      gap: theme.spacing(2),
      justifyContent: "center",
      padding: `${theme.spacing(2)} 0 0 ${theme.spacing(2)}`,
      [formatMedia.BREAKPOINT_TABLET]: {
        gap: theme.spacing(3),
        padding: `${theme.spacing(3)} 0 0 ${theme.spacing(3)}`,
      },
    },
    [`& .${ARTICLE_PRODUCT_CARD_CLASSES.productCardBox}`]: {
      flex: 1,
      flexGrow: 1,
      width: "43.467vw",
      maxWidth: "600px !important",

      [formatMedia.BREAKPOINT_DESKTOP]: {
        width: "91.467vw",
      },
    },
  };
});
